import { render, staticRenderFns } from "./PublicRGUserContactInfo.vue?vue&type=template&id=6b175e0b&scoped=true&"
import script from "./PublicRGUserContactInfo.vue?vue&type=script&lang=ts&"
export * from "./PublicRGUserContactInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PublicRGUserContactInfo.vue?vue&type=style&index=0&id=6b175e0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b175e0b",
  null
  
)

export default component.exports